/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconZoomOut = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-zoom-out',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "m19.678 21-5.95-5.95a5.756 5.756 0 0 1-3.589 1.228c-1.716 0-3.168-.594-4.356-1.783C4.594 13.307 4 11.855 4 10.14c0-1.716.594-3.168 1.783-4.356C6.97 4.594 8.423 4 10.139 4c1.716 0 3.168.594 4.356 1.783 1.189 1.188 1.783 2.64 1.783 4.356a5.756 5.756 0 0 1-1.228 3.589l5.95 5.95L19.678 21Zm-9.54-6.611c1.181 0 2.185-.413 3.011-1.24.827-.826 1.24-1.83 1.24-3.01 0-1.18-.413-2.184-1.24-3.01-.826-.827-1.83-1.24-3.01-1.24-1.18 0-2.184.413-3.01 1.24-.827.826-1.24 1.83-1.24 3.01 0 1.18.413 2.184 1.24 3.01.826.827 1.83 1.24 3.01 1.24Zm-2.36-3.306V9.194H12.5v1.89H7.778Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconZoomOut.displayName = 'IconZoomOut';
export default IconZoomOut;
